import { withOverlayControls } from '@eventbrite/eds-structure';
import { checkGate } from '@eventbrite/statsig';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TLD_UNITED_STATES } from '../../../../constants/constants';
import { FULLBLEED_CREATOR_HEADER } from '../../../../constants/seasonal';
import { HeaderShape, UserShape } from '../../../../types/index';
import { HeaderTitle } from '../../components/HeaderTitle';
import { HomeEngagementExperimentTrackingLocations } from '../../constants/analytics';
import { clickCTASeasonal } from '../../redux/content/actions';
import { logToStatsigHomeEngagement } from '../../utils/analytics';
import { FullbleedHeaderBackgroundContainer } from '../FullbleedHeaderBackgroundContainer';
import './FullbleedHeader.scss';

const CREATOR_BANNER = 'homepage_creator_banner_test';
const CREATOR_BANNER_ALLOCATION = 'home_creator_banner_allocation';
interface FullbleedHeaderProps {
    isLoading: boolean;
    history?: object;
    header: HeaderShape;
    clickCTASeasonal?: Function;
    siteInfo: {
        tld?: string;
        locale?: string;
    };
    user: UserShape;
}

interface FullbleedHeaderState {
    variant: HeaderShape;
}

const showCreatorHeader = (
    tld?: string,
    locale?: string,
    user?: UserShape,
): boolean => {
    const isLoggedUser = !!user?.publicId;
    const isLoggedUserWithoutEvents = isLoggedUser && !user.orgHasEvents;
    const isSiteEligible =
        tld === TLD_UNITED_STATES &&
        locale === 'en_US' &&
        checkGate(CREATOR_BANNER_ALLOCATION);

    if (isSiteEligible && (!isLoggedUser || isLoggedUserWithoutEvents)) {
        return checkGate(CREATOR_BANNER);
    }
    return false;
};
export class FullbleedHeader extends Component<
    FullbleedHeaderProps,
    FullbleedHeaderState
> {
    handleHeaderCTASeasonalClick() {
        const { clickCTASeasonal, user } = this.props;
        logToStatsigHomeEngagement(
            HomeEngagementExperimentTrackingLocations.CITY_CTA,
            !!user.isAuthenticated,
        );
        clickCTASeasonal?.();
    }

    componentDidMount(): void {
        const { header, siteInfo, user } = this.props;
        const creatorHeader = Object.assign(
            {},
            header,
            FULLBLEED_CREATOR_HEADER,
        );
        const variant = {
            variant: showCreatorHeader(siteInfo.tld, siteInfo.locale, user)
                ? creatorHeader
                : header,
        };
        this.setState(variant);
    }

    render() {
        const { header } = this.props;

        return (
            <section className="feed-fullbleed-header">
                <div className="feed-fullbleed-header__wrapper">
                    <FullbleedHeaderBackgroundContainer
                        type="MainHeaderBackground"
                        isSeasonal={header?.shouldShowCustomContent}
                        placeholder={header?.headerImagePlaceholder}
                    />

                    <div className="feed-fullbleed-header__content">
                        <div className="eds-layout eds-layout--has-large-max-width eds-layout--has-horizontal-gutters">
                            <div className="eds-layout__body">
                                {this.state?.variant && (
                                    <HeaderTitle
                                        header={this.state.variant}
                                        clickCTASeasonal={this.handleHeaderCTASeasonalClick.bind(
                                            this,
                                        )}
                                        fullbleed={true}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const _mapStateToProps = ({
    header,
    app,
    user,
}: {
    header: HeaderShape;
    app: {
        loadingState?: {
            isFeLoading?: boolean;
        };
        locale: string;
        tld: string;
    };
    user: UserShape;
}) => ({
    header,
    isLoading: app.loadingState && app.loadingState.isFeLoading,
    siteInfo: {
        locale: app.locale,
        tld: app.tld,
    },
    user,
});

const _mapDispatchToProps = {
    clickCTASeasonal,
};

export default withOverlayControls(
    connect(_mapStateToProps, _mapDispatchToProps)(FullbleedHeader),
);
